"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_confetti_1 = __importDefault(require("react-confetti"));
var Transition_1 = __importDefault(require("react-transition-group/Transition"));
var CONFETTI_CANVAS_SIZE = 800;
var CONFETTI_SOURCE = {
    x: CONFETTI_CANVAS_SIZE - 380 - 16,
    y: CONFETTI_CANVAS_SIZE - 180 - 20,
    w: 380,
    h: 180,
};
var TourConfetti = function (_a) {
    var show = _a.show;
    var _b = __read((0, react_1.useState)(false), 2), recycleConfetti = _b[0], setRecycleConfetti = _b[1];
    (0, react_1.useEffect)(function () {
        setRecycleConfetti(true);
        var timer = setTimeout(function () {
            setRecycleConfetti(false);
        }, 1000);
        return function () { return clearTimeout(timer); };
    }, [show]);
    return (react_1.default.createElement(Transition_1.default, { timeout: 1000, in: show, mountOnEnter: true, unmountOnExit: true }, function (status) { return (react_1.default.createElement(react_confetti_1.default, { className: (0, classnames_1.default)("tour-confetti", "tour-confetti--".concat(status)), recycle: show && recycleConfetti, width: CONFETTI_CANVAS_SIZE, height: CONFETTI_CANVAS_SIZE, confettiSource: CONFETTI_SOURCE, colors: ["#716BF1", "#0BDAC9", "#FFB961"], numberOfPieces: 200 })); }));
};
exports.default = TourConfetti;
